import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AppConstants } from "../constants/constants";
import { Modes } from "../constants/modes";
import { getValueFromQueryParams } from "../shared/url-functions";

@Injectable({
  providedIn: "root",
})
export class ScormCloseService {
  queryParams: string;
  prevPath: string;

  constructor(private router: Router) {}

  closeScorm(panelState: unknown) {
    const url = this.router.url;
    this.prevPath = sessionStorage.getItem(AppConstants.PREV_PATH);
    const scormMode = getValueFromQueryParams(url, AppConstants.SCORM_MODE);

    if (scormMode == null) {
      this.router.navigateByUrl(this.prevPath);
      return;
    }

    switch (+scormMode) {
      case Modes.Review:
        const questionId = getValueFromQueryParams(
          url,
          AppConstants.QUESTION_ID
        );
        this.router.navigateByUrl(this.prevPath, {
          state: { qId: questionId, savedQsetPanelState: panelState },
        });

        break;
      case Modes.Tracked:
      case Modes.Screener:
        this.router.navigateByUrl(this.prevPath);
        break;
      default:
        this.router.navigateByUrl(this.prevPath);
        break;
    }
  }
}
